import React, {Component} from 'react'

import {connect} from 'react-redux'
import actionCreators from '../actions/shared-dataset'
import WrappedComponent from '../components/DatasetGateway.js'
import { bindActionCreators } from 'redux'
import {datasetSelector} from '../selectors'
class DatasetGateway extends Component 
{
  componentDidMount()
  {
    this.props.onLoad(this.props.match.params.public_guid)
  }

  render() 
  {
    return (<WrappedComponent {...this.props} />)
  }
}

let mapStateToProps = (state) => ({
  dataset: datasetSelector(state)
})

let mapDispatchToProps = (dispatch) => {
  let actions = bindActionCreators(actionCreators, dispatch)

  return {
    onLoad: public_guid => {actions.get_dataset(public_guid)}
  }
}

let ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(DatasetGateway)

export default ConnectedComponent


// WEBPACK FOOTER //
// ./src/containers/DatasetGateway.js